import React, { useRef } from "react";
import { CommunityTitle } from "../../../../components/community/community-title";
import { MAKEMAKE_LIVE_PLAYLISTS } from "../../../data/makemake-live";
import { useTranslations } from "../../../../hooks/use-translations";
import _ from "lodash";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Mousewheel, Navigation } from "swiper";
import { Icon } from "@iconify/react";

import useIsMobile from "../../../../js/utilities/useIsMobile";
import { useLanguage } from "../../../../hooks/use-language";

export const PastEvents = () => {
	const lang = useLanguage();
	const texts = useTranslations({ section: "comunidad_club", lang: lang });
	const eventsPlaylists = [...MAKEMAKE_LIVE_PLAYLISTS];

	const isMobile = useIsMobile();
	const prevButtonRef = useRef(null);
	const nextButtonRef = useRef(null);

	const updateNavigation = (swiper) => {
		swiper.params.navigation.prevEl = prevButtonRef?.current
		swiper.params.navigation.nextEl = nextButtonRef?.current
		swiper.navigation.destroy()
		swiper.navigation.init()
		swiper.navigation.update()
	}

	return (
		<div className="container">
			<div className="mt-5 mb-4">
				<CommunityTitle.H4
					title={_.get(texts, "makemake_en_vivo.destacados.titulo") || "Destacados"}
				/>

				<div className="d-flex d-lg-none justify-content-end mt-3 mt-lg-0">
					<button ref={prevButtonRef} aria-label="previous" className="home-swiper-navigation-buttons mx-2">
						<Icon className="icon" icon="material-symbols:arrow-back-rounded" width={20} />
					</button>
					<button ref={nextButtonRef} aria-label="next" className="home-swiper-navigation-buttons">
						<Icon className="icon" icon="material-symbols:arrow-forward-rounded" width={20} />
					</button>
				</div>
			</div>
			{
				isMobile ?
					<Swiper
						className=""
						style={{ overflowX: 'hidden' }}
						slidesPerGroup={1}
						slidesPerView={1}
						spaceBetween={40}
						breakpoints={{
							526: {
								slidesPerView: 2,
								slidesPerGroup: 2,
							}
						}}
						autoplay={{
							delay: 5000,
							disableOnInteraction: false,
						}}
						mousewheel={{
							forceToAxis: true,
						}}
						navigation={{
							nextEl: nextButtonRef?.current,
							prevEl: prevButtonRef?.current,
						}}
						onSwiper={(swiper) => {
							updateNavigation(swiper);
						}}
						modules={[Autoplay, Navigation, Mousewheel]}
					>
						{eventsPlaylists.map((playlist) => {
							return (
								<SwiperSlide
									className="past-event-card-container"
									key={`res-${playlist?.id}`}
								>
									<div>
										<iframe
											width={"100%"}
											style={{ borderRadius: 10 }}
											src={`${playlist?.url}`}
											title={playlist?.name?.default || "video youtube"}
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
											referrerPolicy="strict-origin-when-cross-origin"
											allowFullScreen
										></iframe>
									</div>


									<p className="title secondary-font onbackground-primary--color my-2 mt-lg-2 mb-lg-0">
										{_.get(texts, playlist?.name?.translationPath) ||
											playlist?.name?.default}
									</p>
								</SwiperSlide>
							);
						})}
					</Swiper>

					:
					<ul className="d-flex justify-content-between align-items-start flex-wrap">
						{eventsPlaylists?.map((playlist, i) => {
							return (

								<li
									key={playlist?.id}
									className={`past-event-card-container ${playlist?.onMobile ? "d-block" : "d-none d-lg-block"}`}
								>
									<div>
										<iframe
											width={"100%"}
											style={{ borderRadius: 10 }}
											src={`${playlist?.url}`}
											title={playlist?.name?.default || "video youtube"}
											frameBorder="0"
											allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
											referrerPolicy="strict-origin-when-cross-origin"
											allowFullScreen
										></iframe>
									</div>


									<p className="title secondary-font onbackground-primary--color my-2 mt-lg-2 mb-lg-0">
										{_.get(texts, playlist?.name?.translationPath) ||
											playlist?.name?.default}
									</p>
								</li>
							);
						})}
					</ul>
			}
		</div>
	);
};
